import type { AIModelChoices, Annotation } from 'api';

import type { MobileZoom } from '../../utils/canvas/canvas';
import { useCanvasRendering } from '../useCanvasRendering/useCanvasRendering';
import { useDesktopZoom } from '../useDesktopZoom/useDesktopZoom';

interface UseSegmentationOverlayProps {
  imageSrc: string;
  annotations: Annotation[];
  hiddenCategories: readonly string[];
  model: AIModelChoices;
  showLegend: boolean;
  showAerosols: boolean;
  isMobile: boolean;
  mobileZoom: MobileZoom;
  canvasRef: React.RefObject<HTMLCanvasElement | null>;
}

export const useSegmentationOverlay = ({
  imageSrc,
  annotations,
  hiddenCategories,
  model,
  showLegend,
  isMobile,
  showAerosols,
  mobileZoom,
  canvasRef,
}: UseSegmentationOverlayProps) => {
  const desktopZoom = useDesktopZoom({ canvasRef, isMobile });
  const canvasRendering = useCanvasRendering({
    annotations,
    canvasRef,
    hiddenCategories,
    imageSrc,
    isMobile,
    mobileZoom,
    model,
    showAerosols,
    showLegend,
  });

  return {
    canvasRect: desktopZoom.canvasRect,
    isLoading: canvasRendering.isLoading,
    isZoomVisible: desktopZoom.isZoomVisible,
    labelColourMap: canvasRendering.labelColourMap,
    mousePosition: desktopZoom.mousePosition,
    scale: canvasRendering.scale,
    visibleAnnotations: canvasRendering.visibleAnnotations,
  };
};
